import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {WixView} from "../views/wix";

export class WixFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new WixView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/wix`;
    }

}
